export default __webpack_public_path__ + "static/media/diy-investing.fb693707.png";